<a [routerLink]="['/assets']" [queryParams]="$queryParams()">
    <cm-button class="cm-action-button" (click)="activated.emit(true)">
        <ng-container cm-left-icon>
            <i class="far fa-couch"></i>
        </ng-container>
        <ng-container cm-text> Show assets</ng-container>
    </cm-button>
</a>
